import { usePaymentDetails } from "@/apis/payments/hooks/useGetPaymentDetail";
import PageLoader from "@/app/common/components/PageLoader/PageLoader";
import { selectProgramID } from "@/storage/program_settings/programSettingsSlice";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ProviderAppealLayout } from "./provider_appeal_layout";
import { AppealReimbursementPage } from "./reimbursement_appeal";

export function PaymentAppealPage() {
  const params = useParams()
  const programId = useSelector(selectProgramID)

  const paymentDetailsQuery = usePaymentDetails({
    payment_id: `${params.id}`,
    program_id: programId,
  })




  return (
    <div>
      <PageLoader query={paymentDetailsQuery}>
        {(data) => {
          
          if (data.type === "Reimbursement") {
            return (
              <AppealReimbursementPage payment={data} />
            )
          }

          if(data.type === "Pay Provider") {
            return (
              <ProviderAppealLayout payment={data} />
            )
          }

        }}
      </PageLoader>
    </div>
  )
}
